// import { useState, useRef, useCallback, useEffect } from "react";
// import {
//   Table, Button, Tooltip, Typography, Progress, Tag, Space,
//   Card, Input, message, ConfigProvider, Modal
// } from "antd";
// import {
//   UploadOutlined, CopyOutlined, LinkOutlined,
//   CheckOutlined, VideoCameraOutlined, PictureOutlined,
//   CloudUploadOutlined, DeleteOutlined, ExclamationCircleOutlined,
//   FilePdfOutlined
// } from "@ant-design/icons";
// const { Text, Title } = Typography;
// // ─── S3 / Supabase config ─────────────────────────────────────────────────────
// const S3_ENDPOINT       = "https://izeiyujebczudhvsvbon.storage.supabase.co/storage/v1/s3";
// const ACCESS_KEY_ID     = "247f98d16d157a3239f5d48b9ca58a86";
// const SECRET_ACCESS_KEY = "dc7ebbaf68286d72a36af46ba7f01e45780f22151054cdf493def7d40e7e9f6c";
// const BUCKET            = "bucket";
// const REGION            = "auto";
// const PUBLIC_BASE       = "https://izeiyujebczudhvsvbon.supabase.co/storage/v1/object/public";
// // ─── File type helpers ────────────────────────────────────────────────────────
// function isImage(f) { return f && f.type.startsWith("image/"); }
// function isVideo(f) { return f && f.type.startsWith("video/"); }
// function isPdf(f)   { return f && f.type === "application/pdf"; }
// function isAccepted(f) { return isImage(f) || isVideo(f) || isPdf(f); }
// function fileTypeLabel(f) {
//   if (!f) return "";
//   if (isImage(f)) return "image";
//   if (isVideo(f)) return "video";
//   if (isPdf(f))   return "pdf";
//   return "file";
// }
// function sizeLabel(bytes) {
//   if (bytes >= 1024 * 1024) return (bytes / (1024 * 1024)).toFixed(1) + " MB";
//   return (bytes / 1024).toFixed(1) + " KB";
// }
// const VIDEO_EXTS = ["mp4","webm","ogg","mov","avi","mpeg","mkv"];
// const PDF_EXTS   = ["pdf"];
// function isVideoKey(key = "") {
//   return VIDEO_EXTS.includes(key.split(".").pop().toLowerCase());
// }
// function isPdfKey(key = "") {
//   return PDF_EXTS.includes(key.split(".").pop().toLowerCase());
// }
// // ─── AWS4 helpers ─────────────────────────────────────────────────────────────
// async function hmacSha256(key, data) {
//   const k  = typeof key === "string" ? new TextEncoder().encode(key) : key;
//   const ck = await crypto.subtle.importKey("raw", k, { name:"HMAC", hash:"SHA-256" }, false, ["sign"]);
//   return new Uint8Array(await crypto.subtle.sign("HMAC", ck, new TextEncoder().encode(data)));
// }
// async function sha256hex(data) {
//   const buf = data instanceof ArrayBuffer ? data : new TextEncoder().encode(data);
//   return Array.from(new Uint8Array(await crypto.subtle.digest("SHA-256", buf)))
//     .map(b => b.toString(16).padStart(2,"0")).join("");
// }
// function toHex(b) { return Array.from(b).map(x => x.toString(16).padStart(2,"0")).join(""); }
// async function awsSign({ method, url, contentType, amzdate, datestamp, payloadHash }) {
//   const u    = new URL(url);
//   const host = u.host;
//   const canonicalUri = "/" + u.pathname.slice(1).split("/").map(encodeURIComponent).join("/");
//   const qParams = [...u.searchParams.entries()]
//     .sort(([a],[b]) => a < b ? -1 : a > b ? 1 : 0)
//     .map(([k,v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`).join("&");
//   const headers = contentType
//     ? `content-type:${contentType}\nhost:${host}\nx-amz-content-sha256:${payloadHash}\nx-amz-date:${amzdate}\n`
//     : `host:${host}\nx-amz-content-sha256:${payloadHash}\nx-amz-date:${amzdate}\n`;
//   const signed = contentType
//     ? "content-type;host;x-amz-content-sha256;x-amz-date"
//     : "host;x-amz-content-sha256;x-amz-date";
//   const canon = [method, canonicalUri, qParams, headers, signed, payloadHash].join("\n");
//   const cred  = `${datestamp}/${REGION}/s3/aws4_request`;
//   const sts   = ["AWS4-HMAC-SHA256", amzdate, cred, await sha256hex(canon)].join("\n");
//   const kD = await hmacSha256("AWS4" + SECRET_ACCESS_KEY, datestamp);
//   const kR = await hmacSha256(kD, REGION);
//   const kS = await hmacSha256(kR, "s3");
//   const kK = await hmacSha256(kS, "aws4_request");
//   const sig = toHex(await hmacSha256(kK, sts));
//   return `AWS4-HMAC-SHA256 Credential=${ACCESS_KEY_ID}/${cred}, SignedHeaders=${signed}, Signature=${sig}`;
// }
// // ─── List bucket files ────────────────────────────────────────────────────────
// async function listBucketFiles() {
//   const now        = new Date();
//   const datestamp  = now.toISOString().slice(0,10).replace(/-/g,"");
//   const amzdate    = now.toISOString().replace(/[-:]/g,"").slice(0,15) + "Z";
//   const EMPTY_HASH = "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855";
//   const url        = `${S3_ENDPOINT}/${BUCKET}?list-type=2&prefix=uploads%2F`;
//   const auth = await awsSign({ method:"GET", url, contentType:null, amzdate, datestamp, payloadHash:EMPTY_HASH });
//   const res  = await fetch(url, {
//     headers:{ "x-amz-date":amzdate, "x-amz-content-sha256":EMPTY_HASH, Authorization:auth },
//   });
//   if (!res.ok) throw new Error(`List failed: ${res.status}`);
//   const xml   = await res.text();
//   const items = [];
//   const rx    = /<Contents>([\s\S]*?)<\/Contents>/g;
//   let m;
//   while ((m = rx.exec(xml)) !== null) {
//     const block = m[1];
//     const key  = (block.match(/<Key>([^<]+)<\/Key>/)                   || [])[1] || "";
//     const size = (block.match(/<Size>([^<]+)<\/Size>/)                  || [])[1] || "0";
//     const mod  = (block.match(/<LastModified>([^<]+)<\/LastModified>/)  || [])[1] || "";
//     if (!key) continue;
//     const name    = key.split("/").pop();
//     const itemUrl = `${PUBLIC_BASE}/${BUCKET}/${key}`;
//     const bytes   = parseInt(size, 10);
//     const time    = mod ? new Date(mod).toLocaleString([], { month:"short", day:"numeric", hour:"2-digit", minute:"2-digit" }) : "";
//     const rawMod  = mod ? new Date(mod).getTime() : 0;
//     items.push({ key, name, url:itemUrl, size:sizeLabel(bytes), time, rawMod });
//   }
//   items.sort((a,b) => b.rawMod - a.rawMod);
//   return items;
// }
// // ─── Delete file from S3 ──────────────────────────────────────────────────────
// async function deleteS3File(s3Key) {
//   const now         = new Date();
//   const datestamp   = now.toISOString().slice(0,10).replace(/-/g,"");
//   const amzdate     = now.toISOString().replace(/[-:]/g,"").slice(0,15) + "Z";
//   const EMPTY_HASH  = "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855";
//   const deleteUrl   = `${S3_ENDPOINT}/${BUCKET}/${s3Key}`;
//   const auth = await awsSign({
//     method: "DELETE",
//     url: deleteUrl,
//     contentType: null,
//     amzdate,
//     datestamp,
//     payloadHash: EMPTY_HASH,
//   });
//   const res = await fetch(deleteUrl, {
//     method: "DELETE",
//     headers: {
//       "x-amz-date": amzdate,
//       "x-amz-content-sha256": EMPTY_HASH,
//       Authorization: auth,
//     },
//   });
//   if (!res.ok && res.status !== 204) {
//     const t = await res.text();
//     throw new Error(`Delete failed (${res.status}): ${t.slice(0, 200)}`);
//   }
// }
// // ─── Main component ───────────────────────────────────────────────────────────
// export default function MediaUploader() {
//   const [file,        setFile]        = useState(null);
//   const [fileLabel,   setFileLabel]   = useState("");
//   const [customName,  setCustomName]  = useState("");
//   const [preview,     setPreview]     = useState(null);
//   const [publicUrl,   setPublicUrl]   = useState("");
//   const [uploading,   setUploading]   = useState(false);
//   const [progress,    setProgress]    = useState(0);
//   const [drag,        setDrag]        = useState(false);
//   const [copied,      setCopied]      = useState(false);
//   const [uploads,     setUploads]     = useState([]);
//   const [copiedKey,   setCopiedKey]   = useState(null);
//   const [loading,     setLoading]     = useState(true);
//   const [deletingKey, setDeletingKey] = useState(null);
//   const fileRef    = useRef();
//   const prevUrlRef = useRef(null);
//   const [messageApi, contextHolder]   = message.useMessage();
//   const [modal, modalContextHolder]   = Modal.useModal();

//   useEffect(() => {
//     listBucketFiles()
//       .then(items => setUploads(items))
//       .catch(e => console.error("List error:", e))
//       .finally(() => setLoading(false));
//   }, []);

//   const handleFile = (f) => {
//     if (!f || !isAccepted(f)) {
//       messageApi.error("Please select an image, video, or PDF file.");
//       return;
//     }
//     if (prevUrlRef.current) { URL.revokeObjectURL(prevUrlRef.current); prevUrlRef.current = null; }
//     setFile(f); setCustomName(""); setPublicUrl(""); setProgress(0);
//     setFileLabel(fileTypeLabel(f));
//     if (isImage(f)) {
//       const reader = new FileReader();
//       reader.onload = (e) => setPreview(e.target.result);
//       reader.readAsDataURL(f);
//     } else if (isVideo(f)) {
//       const objUrl = URL.createObjectURL(f);
//       prevUrlRef.current = objUrl;
//       setPreview(objUrl);
//     } else {
//       // PDF — no inline preview, just clear any old preview
//       setPreview(null);
//     }
//   };

//   const onDrop = useCallback((e) => {
//     e.preventDefault(); setDrag(false);
//     handleFile(e.dataTransfer.files[0]);
//   }, []);

//   const handleUpload = async () => {
//     if (!file) return;
//     try {
//       setUploading(true); setProgress(10); setPublicUrl("");
//       const ext         = file.name.split(".").pop();
//       const s3Key       = `uploads/${Date.now()}_${Math.random().toString(36).slice(2)}.${ext}`;
//       const uploadUrl   = `${S3_ENDPOINT}/${BUCKET}/${s3Key}`;
//       const now         = new Date();
//       const datestamp   = now.toISOString().slice(0,10).replace(/-/g,"");
//       const amzdate     = now.toISOString().replace(/[-:]/g,"").slice(0,15) + "Z";
//       const fileBuffer  = await file.arrayBuffer();
//       const payloadHash = await sha256hex(fileBuffer);
//       setProgress(35);
//       const auth = await awsSign({ method:"PUT", url:uploadUrl, contentType:file.type, amzdate, datestamp, payloadHash });
//       setProgress(55);
//       const res = await fetch(uploadUrl, {
//         method: "PUT",
//         headers: { "Content-Type":file.type, "x-amz-date":amzdate, "x-amz-content-sha256":payloadHash, Authorization:auth },
//         body: fileBuffer,
//       });
//       setProgress(85);
//       if (!res.ok) { const t = await res.text(); throw new Error(`Upload failed (${res.status}): ${t.slice(0,200)}`); }
//       const url = `${PUBLIC_BASE}/${BUCKET}/${s3Key}`;
//       setProgress(100);
//       setPublicUrl(url);
//       messageApi.success("Uploaded successfully!");
//       const displayName = customName.trim() || file.name;
//       setUploads(prev => [{
//         key: s3Key, name: displayName, url,
//         size: sizeLabel(file.size),
//         time: now.toLocaleString([], { month:"short", day:"numeric", hour:"2-digit", minute:"2-digit" }),
//         rawMod: now.getTime(),
//       }, ...prev]);
//     } catch(err) {
//       messageApi.error(err.message || "Upload failed.");
//       setProgress(0);
//     } finally {
//       setUploading(false);
//       setTimeout(() => setProgress(0), 1000);
//     }
//   };

//   // ─── Delete handler ──────────────────────────────────────────────────────────
//   const handleDelete = (record) => {
//     modal.confirm({
//       title: "Delete file?",
//       icon: <ExclamationCircleOutlined style={{ color: "#ff4d4f" }} />,
//       content: (
//         <span>
//           <strong>{record.name}</strong> will be permanently removed from storage.
//         </span>
//       ),
//       okText: "Delete",
//       okButtonProps: { danger: true },
//       cancelText: "Cancel",
//       onOk: async () => {
//         setDeletingKey(record.key);
//         try {
//           await deleteS3File(record.key);
//           setUploads(prev => prev.filter(u => u.key !== record.key));
//           if (publicUrl === record.url) setPublicUrl("");
//           messageApi.success("File deleted.");
//         } catch (err) {
//           messageApi.error(err.message || "Delete failed.");
//         } finally {
//           setDeletingKey(null);
//         }
//       },
//     });
//   };

//   const copyToClipboard = (text, rowKey) => {
//     navigator.clipboard.writeText(text).then(() => {
//       if (rowKey !== undefined) {
//         setCopiedKey(rowKey);
//         setTimeout(() => setCopiedKey(null), 2000);
//       } else {
//         setCopied(true);
//         setTimeout(() => setCopied(false), 2000);
//       }
//     });
//   };

//   const isVid    = file && isVideo(file);
//   const isPdfFile = file && isPdf(file);
//   const canUpload = !!file && !uploading;

//   // ─── Drop zone icon & hint ────────────────────────────────────────────────
//   function dropZoneEmoji() {
//     if (!file) return "📁";
//     if (isVid) return "🎬";
//     if (isPdfFile) return "📄";
//     return "🖼️";
//   }

//   // ─── Ant Design Table columns ──────────────────────────────────────────────
//   const columns = [
//     {
//       title: "",
//       dataIndex: "url",
//       key: "thumb",
//       width: 52,
//       render: (url, record) => {
//         if (isPdfKey(record.key)) {
//           return (
//             <div style={{
//               width: 36, height: 36, borderRadius: 6,
//               background: "#fff1f0", border: "1px solid #ffccc7",
//               display: "flex", alignItems: "center", justifyContent: "center",
//             }}>
//               <FilePdfOutlined style={{ fontSize: 18, color: "#ff4d4f" }} />
//             </div>
//           );
//         }
//         if (isVideoKey(record.key)) {
//           return (
//             <div style={{
//               width: 36, height: 36, borderRadius: 6,
//               background: "#f0f0f0", border: "1px solid #e8e8e8",
//               display: "flex", alignItems: "center", justifyContent: "center",
//             }}>
//               <VideoCameraOutlined style={{ fontSize: 18, color: "#1677ff" }} />
//             </div>
//           );
//         }
//         return (
//           <img
//             src={url}
//             alt={record.name}
//             style={{ width:36, height:36, borderRadius:6, objectFit:"cover", border:"1px solid #e8e8e8", display:"block" }}
//             onError={e => {
//               e.target.style.display = "none";
//               const wrap = e.target.parentNode;
//               if (wrap) {
//                 const icon = document.createElement("div");
//                 icon.style.cssText = "width:36px;height:36px;border-radius:6px;background:#f0f0f0;border:1px solid #e8e8e8;display:flex;align-items:center;justify-content:center;font-size:18px;";
//                 icon.textContent = "🖼️";
//                 wrap.appendChild(icon);
//               }
//             }}
//           />
//         );
//       },
//     },
//     {
//       title: "File",
//       dataIndex: "name",
//       key: "name",
//       ellipsis: true,
//       render: (name, record) => (
//         <div>
//           <Text strong style={{ fontSize: 13, display:"block" }} ellipsis={{ tooltip: name }}>
//             {name}
//           </Text>
//           <Text type="secondary" style={{ fontSize: 11 }}>{record.time}</Text>
//         </div>
//       ),
//     },
//     {
//       title: "Public URL",
//       dataIndex: "url",
//       key: "url",
//       ellipsis: true,
//       responsive: ["md"],
//       render: (url) => (
//         <Tooltip title={url}>
//           <a
//             href={url}
//             target="_blank"
//             rel="noopener noreferrer"
//             style={{ fontSize: 12, fontFamily:"monospace" }}
//           >
//             {url}
//           </a>
//         </Tooltip>
//       ),
//     },
//     {
//       title: "Size",
//       dataIndex: "size",
//       key: "size",
//       width: 72,
//       responsive: ["sm"],
//       render: (size) => (
//         <Tag color="default" style={{ fontSize:11 }}>{size}</Tag>
//       ),
//     },
//     {
//       title: "Actions",
//       key: "actions",
//       width: 116,
//       render: (_, record) => (
//         <Space size={4}>
//           <Tooltip title={copiedKey === record.key ? "Copied!" : "Copy URL"}>
//             <Button
//               size="small"
//               icon={copiedKey === record.key ? <CheckOutlined style={{ color:"#52c41a" }} /> : <CopyOutlined />}
//               onClick={() => copyToClipboard(record.url, record.key)}
//             />
//           </Tooltip>
//           <Tooltip title="Open in new tab">
//             <Button
//               size="small"
//               icon={<LinkOutlined />}
//               onClick={() => window.open(record.url, "_blank", "noopener,noreferrer")}
//             />
//           </Tooltip>
//           <Tooltip title="Delete file">
//             <Button
//               size="small"
//               danger
//               icon={<DeleteOutlined />}
//               loading={deletingKey === record.key}
//               onClick={() => handleDelete(record)}
//             />
//           </Tooltip>
//         </Space>
//       ),
//     },
//   ];

//   return (
//     <ConfigProvider
//       theme={{
//         token: {
//           colorPrimary: "#1677ff",
//           borderRadius: 8,
//           fontFamily: "system-ui, -apple-system, sans-serif",
//         },
//       }}
//     >
//       {contextHolder}
//       {modalContextHolder}
//       <div style={{ minHeight:"100vh", background:"#f4f6f9", padding:"16px 12px", boxSizing:"border-box" }}>
//         <div style={{ maxWidth:760, margin:"0 auto", display:"flex", flexDirection:"column", gap:16 }}>
//           {/* ── Uploader card ── */}
//           <Card
//             bordered={false}
//             style={{ borderRadius:14, boxShadow:"0 1px 4px rgba(0,0,0,0.08)" }}
//             bodyStyle={{ padding:"20px 16px", display:"flex", flexDirection:"column", gap:16 }}
//           >
//             {/* Header */}
//             <div>
//               <Title level={4} style={{ margin:0, fontSize:17 }}>
//                 <CloudUploadOutlined style={{ marginRight:8, color:"#1677ff" }} />
//                 Media Uploader
//               </Title>
//               <Text type="secondary" style={{ fontSize:13 }}>
//                 Upload images, videos, or PDFs · get a public link instantly
//               </Text>
//             </div>
//             {/* Drop zone */}
//             <div
//               onClick={() => fileRef.current.click()}
//               onDragOver={(e) => { e.preventDefault(); setDrag(true); }}
//               onDragLeave={() => setDrag(false)}
//               onDrop={onDrop}
//               style={{
//                 border: `2px dashed ${drag ? "#1677ff" : "#d9d9d9"}`,
//                 borderRadius: 10,
//                 padding: "28px 16px",
//                 textAlign: "center",
//                 cursor: "pointer",
//                 background: drag ? "#e6f4ff" : "#fafafa",
//                 transition: "all 0.2s",
//                 WebkitTapHighlightColor: "transparent",
//               }}
//             >
//               <div style={{ fontSize:32, marginBottom:8 }}>{dropZoneEmoji()}</div>
//               <Text style={{ fontSize:14, color:"#555", display:"block", marginBottom:4 }}>
//                 {file ? file.name : "Tap or drag a file here"}
//               </Text>
//               <Text type="secondary" style={{ fontSize:12 }}>
//                 Images: PNG, JPG, GIF, WebP · Videos: MP4, WebM, MOV · PDFs — up to 500 MB
//               </Text>
//               <input
//                 ref={fileRef}
//                 type="file"
//                 accept="image/*,video/*,application/pdf"
//                 style={{ display:"none" }}
//                 onChange={(e) => e.target.files[0] && handleFile(e.target.files[0])}
//               />
//             </div>
//             {/* Preview — image */}
//             {preview && !isVid && (
//               <div style={{ borderRadius:10, overflow:"hidden", border:"1px solid #f0f0f0" }}>
//                 <img src={preview} alt="preview" style={{ width:"100%", display:"block", maxHeight:200, objectFit:"cover" }} />
//                 <div style={{ fontSize:12, color:"#999", padding:"5px 10px", background:"#fafafa", borderTop:"1px solid #f0f0f0", whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>
//                   <PictureOutlined style={{ marginRight:4 }} />{file?.name}
//                 </div>
//               </div>
//             )}
//             {/* Preview — video */}
//             {preview && isVid && (
//               <div style={{ borderRadius:10, overflow:"hidden", border:"1px solid #f0f0f0", background:"#000" }}>
//                 <video src={preview} controls style={{ width:"100%", display:"block", maxHeight:220, background:"#000" }} />
//                 <div style={{ fontSize:12, color:"#999", padding:"5px 10px", background:"#fafafa", borderTop:"1px solid #f0f0f0", whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>
//                   <VideoCameraOutlined style={{ marginRight:4 }} />{file?.name}
//                 </div>
//               </div>
//             )}
//             {/* Preview — PDF (no inline preview, just a styled info banner) */}
//             {isPdfFile && (
//               <div style={{
//                 display:"flex", alignItems:"center", gap:10,
//                 padding:"10px 14px", borderRadius:8,
//                 background:"#fff1f0", border:"1px solid #ffccc7",
//               }}>
//                 <FilePdfOutlined style={{ fontSize:22, color:"#ff4d4f", flexShrink:0 }} />
//                 <div style={{ minWidth:0 }}>
//                   <Text strong style={{ fontSize:13, display:"block" }} ellipsis={{ tooltip: file.name }}>
//                     {file.name}
//                   </Text>
//                   <Text type="secondary" style={{ fontSize:12 }}>
//                     PDF · {sizeLabel(file.size)}
//                   </Text>
//                 </div>
//               </div>
//             )}
//             {/* Custom name input */}
//             <div>
//               <label style={{ fontSize:12, fontWeight:500, color:"#666", display:"block", marginBottom:6 }}>
//                 {fileLabel === "video" ? "Video" : fileLabel === "pdf" ? "PDF" : "File"} Name{" "}
//                 <Text type="secondary" style={{ fontSize:12, fontWeight:400 }}>(optional — defaults to filename)</Text>
//               </label>
//               <Input
//                 placeholder={file ? file.name : "e.g. hero-banner, promo-video, report…"}
//                 value={customName}
//                 onChange={(e) => setCustomName(e.target.value)}
//                 size="large"
//                 allowClear
//               />
//             </div>
//             {/* Progress bar */}
//             {(uploading || progress > 0) && (
//               <Progress
//                 percent={progress}
//                 size="small"
//                 showInfo={false}
//                 strokeColor="#1677ff"
//                 style={{ marginBottom:0 }}
//               />
//             )}
//             {/* Upload button */}
//             <Button
//               type="primary"
//               size="large"
//               icon={<UploadOutlined />}
//               onClick={handleUpload}
//               disabled={!canUpload}
//               loading={uploading}
//               block
//               style={{ fontWeight:500 }}
//             >
//               {uploading
//                 ? `Uploading ${fileLabel || "file"}…`
//                 : `Upload ${fileLabel ? (fileLabel.charAt(0).toUpperCase() + fileLabel.slice(1)) : "File"}`
//               }
//             </Button>
//             {/* Latest URL output */}
//             {publicUrl && (
//               <>
//                 <div style={{ borderTop:"1px solid #f0f0f0" }} />
//                 <div>
//                   <Text type="secondary" style={{ fontSize:11, fontWeight:500, textTransform:"uppercase", letterSpacing:"0.05em", display:"block", marginBottom:6 }}>
//                     🔗 Public URL
//                   </Text>
//                   <Space.Compact style={{ width:"100%" }}>
//                     <Input
//                       readOnly
//                       value={publicUrl}
//                       onClick={(e) => e.target.select()}
//                       style={{ fontFamily:"monospace", fontSize:12 }}
//                     />
//                     <Tooltip title={copied ? "Copied!" : "Copy URL"}>
//                       <Button
//                         icon={copied ? <CheckOutlined style={{ color:"#52c41a" }} /> : <CopyOutlined />}
//                         onClick={() => copyToClipboard(publicUrl)}
//                       />
//                     </Tooltip>
//                     <Button
//                       type="primary"
//                       icon={<LinkOutlined />}
//                       onClick={() => window.open(publicUrl, "_blank", "noopener,noreferrer")}
//                     >
//                       Open
//                     </Button>
//                   </Space.Compact>
//                 </div>
//               </>
//             )}
//           </Card>
//           {/* ── Uploads Table card ── */}
//           <Card
//             bordered={false}
//             style={{ borderRadius:14, boxShadow:"0 1px 4px rgba(0,0,0,0.08)" }}
//             bodyStyle={{ padding:0 }}
//             title={
//               <Space>
//                 <span>📁 Uploaded Files</span>
//                 <Tag color="blue" style={{ fontWeight:400 }}>
//                   {loading ? "…" : uploads.length}
//                 </Tag>
//               </Space>
//             }
//           >
//             <Table
//               dataSource={uploads}
//               columns={columns}
//               rowKey="key"
//               loading={loading}
//               pagination={{ pageSize:10, size:"small", hideOnSinglePage:true }}
//               size="small"
//               scroll={{ x: "max-content" }}
//               locale={{ emptyText: "No files uploaded yet" }}
//               style={{ borderRadius:"0 0 14px 14px", overflow:"hidden" }}
//             />
//           </Card>
//         </div>
//       </div>
//     </ConfigProvider>
//   );
// }

import { useState, useRef, useCallback, useEffect } from "react";
import {
  Table, Button, Tooltip, Typography, Progress, Tag, Space,
  Card, Input, message, ConfigProvider, Modal
} from "antd";
import {
  UploadOutlined, CopyOutlined, LinkOutlined,
  CheckOutlined, VideoCameraOutlined, PictureOutlined,
  CloudUploadOutlined, DeleteOutlined, ExclamationCircleOutlined,
  FilePdfOutlined
} from "@ant-design/icons";
const { Text, Title } = Typography;

// ─── S3 / Supabase config ─────────────────────────────────────────────────────
const S3_ENDPOINT       = "https://izeiyujebczudhvsvbon.storage.supabase.co/storage/v1/s3";
const ACCESS_KEY_ID     = "247f98d16d157a3239f5d48b9ca58a86";
const SECRET_ACCESS_KEY = "dc7ebbaf68286d72a36af46ba7f01e45780f22151054cdf493def7d40e7e9f6c";
const BUCKET            = "bucket";
const REGION            = "auto";
const PUBLIC_BASE       = "https://izeiyujebczudhvsvbon.supabase.co/storage/v1/object/public";

// ─── Shared uploaded-images store ────────────────────────────────────────────
// Other panels (ImageControlPage) can subscribe to this to get the latest list.
const uploadListeners = new Set();
let _cachedUploads = [];

export function subscribeToUploads(fn) {
  uploadListeners.add(fn);
  fn([..._cachedUploads]);           // fire immediately with current state
  return () => uploadListeners.delete(fn);
}

function broadcastUploads(list) {
  _cachedUploads = list;
  uploadListeners.forEach(fn => fn([...list]));
}

// ─── File type helpers ────────────────────────────────────────────────────────
function isImage(f) { return f && f.type.startsWith("image/"); }
function isVideo(f) { return f && f.type.startsWith("video/"); }
function isPdf(f)   { return f && f.type === "application/pdf"; }
function isAccepted(f) { return isImage(f) || isVideo(f) || isPdf(f); }
function fileTypeLabel(f) {
  if (!f) return "";
  if (isImage(f)) return "image";
  if (isVideo(f)) return "video";
  if (isPdf(f))   return "pdf";
  return "file";
}
function sizeLabel(bytes) {
  if (bytes >= 1024 * 1024) return (bytes / (1024 * 1024)).toFixed(1) + " MB";
  return (bytes / 1024).toFixed(1) + " KB";
}
const VIDEO_EXTS = ["mp4","webm","ogg","mov","avi","mpeg","mkv"];
const PDF_EXTS   = ["pdf"];
function isVideoKey(key = "") {
  return VIDEO_EXTS.includes(key.split(".").pop().toLowerCase());
}
function isPdfKey(key = "") {
  return PDF_EXTS.includes(key.split(".").pop().toLowerCase());
}

// ─── AWS4 helpers ─────────────────────────────────────────────────────────────
async function hmacSha256(key, data) {
  const k  = typeof key === "string" ? new TextEncoder().encode(key) : key;
  const ck = await crypto.subtle.importKey("raw", k, { name:"HMAC", hash:"SHA-256" }, false, ["sign"]);
  return new Uint8Array(await crypto.subtle.sign("HMAC", ck, new TextEncoder().encode(data)));
}
async function sha256hex(data) {
  const buf = data instanceof ArrayBuffer ? data : new TextEncoder().encode(data);
  return Array.from(new Uint8Array(await crypto.subtle.digest("SHA-256", buf)))
    .map(b => b.toString(16).padStart(2,"0")).join("");
}
function toHex(b) { return Array.from(b).map(x => x.toString(16).padStart(2,"0")).join(""); }
async function awsSign({ method, url, contentType, amzdate, datestamp, payloadHash }) {
  const u    = new URL(url);
  const host = u.host;
  const canonicalUri = "/" + u.pathname.slice(1).split("/").map(encodeURIComponent).join("/");
  const qParams = [...u.searchParams.entries()]
    .sort(([a],[b]) => a < b ? -1 : a > b ? 1 : 0)
    .map(([k,v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`).join("&");
  const headers = contentType
    ? `content-type:${contentType}\nhost:${host}\nx-amz-content-sha256:${payloadHash}\nx-amz-date:${amzdate}\n`
    : `host:${host}\nx-amz-content-sha256:${payloadHash}\nx-amz-date:${amzdate}\n`;
  const signed = contentType
    ? "content-type;host;x-amz-content-sha256;x-amz-date"
    : "host;x-amz-content-sha256;x-amz-date";
  const canon = [method, canonicalUri, qParams, headers, signed, payloadHash].join("\n");
  const cred  = `${datestamp}/${REGION}/s3/aws4_request`;
  const sts   = ["AWS4-HMAC-SHA256", amzdate, cred, await sha256hex(canon)].join("\n");
  const kD = await hmacSha256("AWS4" + SECRET_ACCESS_KEY, datestamp);
  const kR = await hmacSha256(kD, REGION);
  const kS = await hmacSha256(kR, "s3");
  const kK = await hmacSha256(kS, "aws4_request");
  const sig = toHex(await hmacSha256(kK, sts));
  return `AWS4-HMAC-SHA256 Credential=${ACCESS_KEY_ID}/${cred}, SignedHeaders=${signed}, Signature=${sig}`;
}

// ─── List bucket files ────────────────────────────────────────────────────────
async function listBucketFiles() {
  const now        = new Date();
  const datestamp  = now.toISOString().slice(0,10).replace(/-/g,"");
  const amzdate    = now.toISOString().replace(/[-:]/g,"").slice(0,15) + "Z";
  const EMPTY_HASH = "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855";
  const url        = `${S3_ENDPOINT}/${BUCKET}?list-type=2&prefix=uploads%2F`;
  const auth = await awsSign({ method:"GET", url, contentType:null, amzdate, datestamp, payloadHash:EMPTY_HASH });
  const res  = await fetch(url, {
    headers:{ "x-amz-date":amzdate, "x-amz-content-sha256":EMPTY_HASH, Authorization:auth },
  });
  if (!res.ok) throw new Error(`List failed: ${res.status}`);
  const xml   = await res.text();
  const items = [];
  const rx    = /<Contents>([\s\S]*?)<\/Contents>/g;
  let m;
  while ((m = rx.exec(xml)) !== null) {
    const block = m[1];
    const key  = (block.match(/<Key>([^<]+)<\/Key>/)                   || [])[1] || "";
    const size = (block.match(/<Size>([^<]+)<\/Size>/)                  || [])[1] || "0";
    const mod  = (block.match(/<LastModified>([^<]+)<\/LastModified>/)  || [])[1] || "";
    if (!key) continue;
    const name    = key.split("/").pop();
    const itemUrl = `${PUBLIC_BASE}/${BUCKET}/${key}`;
    const bytes   = parseInt(size, 10);
    const time    = mod ? new Date(mod).toLocaleString([], { month:"short", day:"numeric", hour:"2-digit", minute:"2-digit" }) : "";
    const rawMod  = mod ? new Date(mod).getTime() : 0;
    items.push({ key, name, url:itemUrl, size:sizeLabel(bytes), time, rawMod });
  }
  items.sort((a,b) => b.rawMod - a.rawMod);
  return items;
}

// ─── Delete file from S3 ──────────────────────────────────────────────────────
async function deleteS3File(s3Key) {
  const now         = new Date();
  const datestamp   = now.toISOString().slice(0,10).replace(/-/g,"");
  const amzdate     = now.toISOString().replace(/[-:]/g,"").slice(0,15) + "Z";
  const EMPTY_HASH  = "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855";
  const deleteUrl   = `${S3_ENDPOINT}/${BUCKET}/${s3Key}`;
  const auth = await awsSign({
    method: "DELETE",
    url: deleteUrl,
    contentType: null,
    amzdate,
    datestamp,
    payloadHash: EMPTY_HASH,
  });
  const res = await fetch(deleteUrl, {
    method: "DELETE",
    headers: {
      "x-amz-date": amzdate,
      "x-amz-content-sha256": EMPTY_HASH,
      Authorization: auth,
    },
  });
  if (!res.ok && res.status !== 204) {
    const t = await res.text();
    throw new Error(`Delete failed (${res.status}): ${t.slice(0, 200)}`);
  }
}

// ─── Main component ───────────────────────────────────────────────────────────
export default function MediaUploader() {
  const [file,        setFile]        = useState(null);
  const [fileLabel,   setFileLabel]   = useState("");
  const [customName,  setCustomName]  = useState("");
  const [preview,     setPreview]     = useState(null);
  const [publicUrl,   setPublicUrl]   = useState("");
  const [uploading,   setUploading]   = useState(false);
  const [progress,    setProgress]    = useState(0);
  const [drag,        setDrag]        = useState(false);
  const [copied,      setCopied]      = useState(false);
  const [uploads,     setUploads]     = useState([]);
  const [copiedKey,   setCopiedKey]   = useState(null);
  const [loading,     setLoading]     = useState(true);
  const [deletingKey, setDeletingKey] = useState(null);
  const fileRef    = useRef();
  const prevUrlRef = useRef(null);
  const [messageApi, contextHolder]   = message.useMessage();
  const [modal, modalContextHolder]   = Modal.useModal();

  useEffect(() => {
    listBucketFiles()
      .then(items => {
        setUploads(items);
        broadcastUploads(items);   // ← seed the shared store
      })
      .catch(e => console.error("List error:", e))
      .finally(() => setLoading(false));
  }, []);

  // ── FIX: Only reset customName when user picks a *new* file from scratch.
  //    We keep whatever they typed if they select a replacement.
  const handleFile = (f) => {
    if (!f || !isAccepted(f)) {
      messageApi.error("Please select an image, video, or PDF file.");
      return;
    }
    if (prevUrlRef.current) { URL.revokeObjectURL(prevUrlRef.current); prevUrlRef.current = null; }

    setFile(f);
    setPublicUrl("");
    setProgress(0);
    setFileLabel(fileTypeLabel(f));

    // Only clear customName when there was NO file before (first pick).
    // If user swaps the file but has already typed a name → preserve it.
    setCustomName(prev => (prev.trim() ? prev : ""));

    if (isImage(f)) {
      const reader = new FileReader();
      reader.onload = (e) => setPreview(e.target.result);
      reader.readAsDataURL(f);
    } else if (isVideo(f)) {
      const objUrl = URL.createObjectURL(f);
      prevUrlRef.current = objUrl;
      setPreview(objUrl);
    } else {
      setPreview(null);
    }
  };

  const onDrop = useCallback((e) => {
    e.preventDefault(); setDrag(false);
    handleFile(e.dataTransfer.files[0]);
  }, []);

  const handleUpload = async () => {
    if (!file) return;
    try {
      setUploading(true); setProgress(10); setPublicUrl("");
      const ext         = file.name.split(".").pop();
      const s3Key       = `uploads/${Date.now()}_${Math.random().toString(36).slice(2)}.${ext}`;
      const uploadUrl   = `${S3_ENDPOINT}/${BUCKET}/${s3Key}`;
      const now         = new Date();
      const datestamp   = now.toISOString().slice(0,10).replace(/-/g,"");
      const amzdate     = now.toISOString().replace(/[-:]/g,"").slice(0,15) + "Z";
      const fileBuffer  = await file.arrayBuffer();
      const payloadHash = await sha256hex(fileBuffer);
      setProgress(35);
      const auth = await awsSign({ method:"PUT", url:uploadUrl, contentType:file.type, amzdate, datestamp, payloadHash });
      setProgress(55);
      const res = await fetch(uploadUrl, {
        method: "PUT",
        headers: { "Content-Type":file.type, "x-amz-date":amzdate, "x-amz-content-sha256":payloadHash, Authorization:auth },
        body: fileBuffer,
      });
      setProgress(85);
      if (!res.ok) { const t = await res.text(); throw new Error(`Upload failed (${res.status}): ${t.slice(0,200)}`); }
      const url = `${PUBLIC_BASE}/${BUCKET}/${s3Key}`;
      setProgress(100);
      setPublicUrl(url);
      messageApi.success("Uploaded successfully!");
      const displayName = customName.trim() || file.name;
      const newEntry = {
        key: s3Key, name: displayName, url,
        size: sizeLabel(file.size),
        time: now.toLocaleString([], { month:"short", day:"numeric", hour:"2-digit", minute:"2-digit" }),
        rawMod: now.getTime(),
      };
      setUploads(prev => {
        const next = [newEntry, ...prev];
        broadcastUploads(next);   // ← keep shared store in sync
        return next;
      });
    } catch(err) {
      messageApi.error(err.message || "Upload failed.");
      setProgress(0);
    } finally {
      setUploading(false);
      setTimeout(() => setProgress(0), 1000);
    }
  };

  const handleDelete = (record) => {
    modal.confirm({
      title: "Delete file?",
      icon: <ExclamationCircleOutlined style={{ color: "#ff4d4f" }} />,
      content: (
        <span>
          <strong>{record.name}</strong> will be permanently removed from storage.
        </span>
      ),
      okText: "Delete",
      okButtonProps: { danger: true },
      cancelText: "Cancel",
      onOk: async () => {
        setDeletingKey(record.key);
        try {
          await deleteS3File(record.key);
          setUploads(prev => {
            const next = prev.filter(u => u.key !== record.key);
            broadcastUploads(next);   // ← keep shared store in sync
            return next;
          });
          if (publicUrl === record.url) setPublicUrl("");
          messageApi.success("File deleted.");
        } catch (err) {
          messageApi.error(err.message || "Delete failed.");
        } finally {
          setDeletingKey(null);
        }
      },
    });
  };

  const copyToClipboard = (text, rowKey) => {
    navigator.clipboard.writeText(text).then(() => {
      if (rowKey !== undefined) {
        setCopiedKey(rowKey);
        setTimeout(() => setCopiedKey(null), 2000);
      } else {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      }
    });
  };

  const isVid     = file && isVideo(file);
  const isPdfFile = file && isPdf(file);
  const canUpload = !!file && !uploading;

  function dropZoneEmoji() {
    if (!file) return "📁";
    if (isVid) return "🎬";
    if (isPdfFile) return "📄";
    return "🖼️";
  }

  const columns = [
    {
      title: "",
      dataIndex: "url",
      key: "thumb",
      width: 52,
      render: (url, record) => {
        if (isPdfKey(record.key)) {
          return (
            <div style={{
              width: 36, height: 36, borderRadius: 6,
              background: "#fff1f0", border: "1px solid #ffccc7",
              display: "flex", alignItems: "center", justifyContent: "center",
            }}>
              <FilePdfOutlined style={{ fontSize: 18, color: "#ff4d4f" }} />
            </div>
          );
        }
        if (isVideoKey(record.key)) {
          return (
            <div style={{
              width: 36, height: 36, borderRadius: 6,
              background: "#f0f0f0", border: "1px solid #e8e8e8",
              display: "flex", alignItems: "center", justifyContent: "center",
            }}>
              <VideoCameraOutlined style={{ fontSize: 18, color: "#1677ff" }} />
            </div>
          );
        }
        return (
          <img
            src={url}
            alt={record.name}
            style={{ width:36, height:36, borderRadius:6, objectFit:"cover", border:"1px solid #e8e8e8", display:"block" }}
            onError={e => {
              e.target.style.display = "none";
              const wrap = e.target.parentNode;
              if (wrap) {
                const icon = document.createElement("div");
                icon.style.cssText = "width:36px;height:36px;border-radius:6px;background:#f0f0f0;border:1px solid #e8e8e8;display:flex;align-items:center;justify-content:center;font-size:18px;";
                icon.textContent = "🖼️";
                wrap.appendChild(icon);
              }
            }}
          />
        );
      },
    },
    {
      title: "File",
      dataIndex: "name",
      key: "name",
      ellipsis: true,
      render: (name, record) => (
        <div>
          <Text strong style={{ fontSize: 13, display:"block" }} ellipsis={{ tooltip: name }}>
            {name}
          </Text>
          <Text type="secondary" style={{ fontSize: 11 }}>{record.time}</Text>
        </div>
      ),
    },
    {
      title: "Public URL",
      dataIndex: "url",
      key: "url",
      ellipsis: true,
      responsive: ["md"],
      render: (url) => (
        <Tooltip title={url}>
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            style={{ fontSize: 12, fontFamily:"monospace" }}
          >
            {url}
          </a>
        </Tooltip>
      ),
    },
    {
      title: "Size",
      dataIndex: "size",
      key: "size",
      width: 72,
      responsive: ["sm"],
      render: (size) => (
        <Tag color="default" style={{ fontSize:11 }}>{size}</Tag>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      width: 116,
      render: (_, record) => (
        <Space size={4}>
          <Tooltip title={copiedKey === record.key ? "Copied!" : "Copy URL"}>
            <Button
              size="small"
              icon={copiedKey === record.key ? <CheckOutlined style={{ color:"#52c41a" }} /> : <CopyOutlined />}
              onClick={() => copyToClipboard(record.url, record.key)}
            />
          </Tooltip>
          <Tooltip title="Open in new tab">
            <Button
              size="small"
              icon={<LinkOutlined />}
              onClick={() => window.open(record.url, "_blank", "noopener,noreferrer")}
            />
          </Tooltip>
          <Tooltip title="Delete file">
            <Button
              size="small"
              danger
              icon={<DeleteOutlined />}
              loading={deletingKey === record.key}
              onClick={() => handleDelete(record)}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#1677ff",
          borderRadius: 8,
          fontFamily: "system-ui, -apple-system, sans-serif",
        },
      }}
    >
      {contextHolder}
      {modalContextHolder}
      <div style={{ minHeight:"100vh", background:"#f4f6f9", padding:"16px 12px", boxSizing:"border-box" }}>
        <div style={{ maxWidth:760, margin:"0 auto", display:"flex", flexDirection:"column", gap:16 }}>
          {/* ── Uploader card ── */}
          <Card
            bordered={false}
            style={{ borderRadius:14, boxShadow:"0 1px 4px rgba(0,0,0,0.08)" }}
            bodyStyle={{ padding:"20px 16px", display:"flex", flexDirection:"column", gap:16 }}
          >
            <div>
              <Title level={4} style={{ margin:0, fontSize:17 }}>
                <CloudUploadOutlined style={{ marginRight:8, color:"#1677ff" }} />
                Media Uploader
              </Title>
              <Text type="secondary" style={{ fontSize:13 }}>
                Upload images, videos, or PDFs · get a public link instantly
              </Text>
            </div>

            {/* Drop zone */}
            <div
              onClick={() => fileRef.current.click()}
              onDragOver={(e) => { e.preventDefault(); setDrag(true); }}
              onDragLeave={() => setDrag(false)}
              onDrop={onDrop}
              style={{
                border: `2px dashed ${drag ? "#1677ff" : "#d9d9d9"}`,
                borderRadius: 10,
                padding: "28px 16px",
                textAlign: "center",
                cursor: "pointer",
                background: drag ? "#e6f4ff" : "#fafafa",
                transition: "all 0.2s",
                WebkitTapHighlightColor: "transparent",
              }}
            >
              <div style={{ fontSize:32, marginBottom:8 }}>{dropZoneEmoji()}</div>
              <Text style={{ fontSize:14, color:"#555", display:"block", marginBottom:4 }}>
                {file ? file.name : "Tap or drag a file here"}
              </Text>
              <Text type="secondary" style={{ fontSize:12 }}>
                Images: PNG, JPG, GIF, WebP · Videos: MP4, WebM, MOV · PDFs — up to 500 MB
              </Text>
              <input
                ref={fileRef}
                type="file"
                accept="image/*,video/*,application/pdf"
                style={{ display:"none" }}
                onChange={(e) => e.target.files[0] && handleFile(e.target.files[0])}
              />
            </div>

            {/* Preview — image */}
            {preview && !isVid && (
              <div style={{ borderRadius:10, overflow:"hidden", border:"1px solid #f0f0f0" }}>
                <img src={preview} alt="preview" style={{ width:"100%", display:"block", maxHeight:200, objectFit:"cover" }} />
                <div style={{ fontSize:12, color:"#999", padding:"5px 10px", background:"#fafafa", borderTop:"1px solid #f0f0f0", whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>
                  <PictureOutlined style={{ marginRight:4 }} />{file?.name}
                </div>
              </div>
            )}

            {/* Preview — video */}
            {preview && isVid && (
              <div style={{ borderRadius:10, overflow:"hidden", border:"1px solid #f0f0f0", background:"#000" }}>
                <video src={preview} controls style={{ width:"100%", display:"block", maxHeight:220, background:"#000" }} />
                <div style={{ fontSize:12, color:"#999", padding:"5px 10px", background:"#fafafa", borderTop:"1px solid #f0f0f0", whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>
                  <VideoCameraOutlined style={{ marginRight:4 }} />{file?.name}
                </div>
              </div>
            )}

            {/* Preview — PDF */}
            {isPdfFile && (
              <div style={{
                display:"flex", alignItems:"center", gap:10,
                padding:"10px 14px", borderRadius:8,
                background:"#fff1f0", border:"1px solid #ffccc7",
              }}>
                <FilePdfOutlined style={{ fontSize:22, color:"#ff4d4f", flexShrink:0 }} />
                <div style={{ minWidth:0 }}>
                  <Text strong style={{ fontSize:13, display:"block" }} ellipsis={{ tooltip: file.name }}>
                    {file.name}
                  </Text>
                  <Text type="secondary" style={{ fontSize:12 }}>
                    PDF · {sizeLabel(file.size)}
                  </Text>
                </div>
              </div>
            )}

            {/* Custom name input */}
            <div>
              <label style={{ fontSize:12, fontWeight:500, color:"#666", display:"block", marginBottom:6 }}>
                {fileLabel === "video" ? "Video" : fileLabel === "pdf" ? "PDF" : "File"} Name{" "}
                <Text type="secondary" style={{ fontSize:12, fontWeight:400 }}>(optional — defaults to filename)</Text>
              </label>
              <Input
                placeholder={file ? file.name : "e.g. hero-banner, promo-video, report…"}
                value={customName}
                onChange={(e) => setCustomName(e.target.value)}
                size="large"
                allowClear
              />
            </div>

            {/* Progress bar */}
            {(uploading || progress > 0) && (
              <Progress
                percent={progress}
                size="small"
                showInfo={false}
                strokeColor="#1677ff"
                style={{ marginBottom:0 }}
              />
            )}

            {/* Upload button */}
            <Button
              type="primary"
              size="large"
              icon={<UploadOutlined />}
              onClick={handleUpload}
              disabled={!canUpload}
              loading={uploading}
              block
              style={{ fontWeight:500 }}
            >
              {uploading
                ? `Uploading ${fileLabel || "file"}…`
                : `Upload ${fileLabel ? (fileLabel.charAt(0).toUpperCase() + fileLabel.slice(1)) : "File"}`
              }
            </Button>

            {/* Latest URL output */}
            {publicUrl && (
              <>
                <div style={{ borderTop:"1px solid #f0f0f0" }} />
                <div>
                  <Text type="secondary" style={{ fontSize:11, fontWeight:500, textTransform:"uppercase", letterSpacing:"0.05em", display:"block", marginBottom:6 }}>
                    🔗 Public URL
                  </Text>
                  <Space.Compact style={{ width:"100%" }}>
                    <Input
                      readOnly
                      value={publicUrl}
                      onClick={(e) => e.target.select()}
                      style={{ fontFamily:"monospace", fontSize:12 }}
                    />
                    <Tooltip title={copied ? "Copied!" : "Copy URL"}>
                      <Button
                        icon={copied ? <CheckOutlined style={{ color:"#52c41a" }} /> : <CopyOutlined />}
                        onClick={() => copyToClipboard(publicUrl)}
                      />
                    </Tooltip>
                    <Button
                      type="primary"
                      icon={<LinkOutlined />}
                      onClick={() => window.open(publicUrl, "_blank", "noopener,noreferrer")}
                    >
                      Open
                    </Button>
                  </Space.Compact>
                </div>
              </>
            )}
          </Card>

          {/* ── Uploads Table card ── */}
          <Card
            bordered={false}
            style={{ borderRadius:14, boxShadow:"0 1px 4px rgba(0,0,0,0.08)" }}
            bodyStyle={{ padding:0 }}
            title={
              <Space>
                <span>📁 Uploaded Files</span>
                <Tag color="blue" style={{ fontWeight:400 }}>
                  {loading ? "…" : uploads.length}
                </Tag>
              </Space>
            }
          >
            <Table
              dataSource={uploads}
              columns={columns}
              rowKey="key"
              loading={loading}
              pagination={{ pageSize:10, size:"small", hideOnSinglePage:true }}
              size="small"
              scroll={{ x: "max-content" }}
              locale={{ emptyText: "No files uploaded yet" }}
              style={{ borderRadius:"0 0 14px 14px", overflow:"hidden" }}
            />
          </Card>
        </div>
      </div>
    </ConfigProvider>
  );
}